import React, { useState } from "react";
import { Link, useNavigate } from "react-router";
import { useCreateBlogMutation } from "../../redux/services/blogService/blog.Services";

function Addblog() {
  const navigate = useNavigate();
  const [createBlog, { isLoading }] = useCreateBlogMutation();

  // FORM STATE
  const [form, setForm] = useState({
    category_id: "",
    title: "",
    subtitle: "",
    slug: "",
    sub_heading: "",
    location: "",
    date: "",
    description: "",
    meta_title: "",
    meta_keywords: "",
    meta_description: "",
    status: "active",
  });

  // FILE STATES
  const [frontImage, setFrontImage] = useState(null);
  const [blogImage2, setBlogImage2] = useState(null);
  const [descriptionImages, setDescriptionImages] = useState([]);

  // PREVIEW
  const [preview, setPreview] = useState({
    front: null,
    blog2: null,
  });

  // HANDLE INPUTS
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // FRONT IMAGE
  const handleFrontImage = (e) => {
    const file = e.target.files[0];
    setFrontImage(file);
    setPreview((prev) => ({
      ...prev,
      front: URL.createObjectURL(file),
    }));
  };

  // BLOG IMAGE 2
  const handleBlogImage2 = (e) => {
    const file = e.target.files[0];
    setBlogImage2(file);
    setPreview((prev) => ({
      ...prev,
      blog2: URL.createObjectURL(file),
    }));
  };

  // MULTIPLE DESCRIPTION IMAGES
  const handleDescriptionImages = (e) => {
    const files = Array.from(e.target.files);
    setDescriptionImages(files);
  };

  // SUBMIT
  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();

    // TEXT DATA
    Object.keys(form).forEach((key) => {
      formData.append(key, form[key]);
    });

    // IMAGES
    if (frontImage) {
      formData.append("front_blog_image", frontImage);
    }

    if (blogImage2) {
      formData.append("blog_image_2", blogImage2);
    }

    descriptionImages.forEach((img) => {
      formData.append("description_images", img);
    });

    try {
      const res = await createBlog(formData).unwrap();
      console.log("Blog Created:", res);

      navigate("/blog-list");
    } catch (error) {
      console.log("Error:", error);
    }
  };

  return (
    <div>
      {/* HEADER */}
      <div className="d-md-flex justify-content-between my-4">
        <h4>Add Blog</h4>

        <button className="btn btn-primary" onClick={() => navigate(-1)}>
          Blog List
        </button>
      </div>

      {/* FORM */}
      <form onSubmit={handleSubmit} className="card p-4">

        <input name="category_id" placeholder="Category ID" onChange={handleChange} className="form-control mb-2" />
        <input name="title" placeholder="Title" onChange={handleChange} className="form-control mb-2" />
        <input name="subtitle" placeholder="Subtitle" onChange={handleChange} className="form-control mb-2" />
        <input name="slug" placeholder="Slug" onChange={handleChange} className="form-control mb-2" />
        <input name="sub_heading" placeholder="Sub Heading" onChange={handleChange} className="form-control mb-2" />
        <input name="location" placeholder="Location" onChange={handleChange} className="form-control mb-2" />
        <input type="date" name="date" onChange={handleChange} className="form-control mb-2" />

        <textarea name="description" placeholder="Description (HTML allowed)" onChange={handleChange} className="form-control mb-2" />

        <input name="meta_title" placeholder="Meta Title" onChange={handleChange} className="form-control mb-2" />
        <input name="meta_keywords" placeholder="Meta Keywords" onChange={handleChange} className="form-control mb-2" />
        <input name="meta_description" placeholder="Meta Description" onChange={handleChange} className="form-control mb-2" />

        {/* IMAGES */}
        <label>Front Image</label>
        <input type="file" onChange={handleFrontImage} className="form-control mb-2" />
        {preview.front && <img src={preview.front} width="120" />}

        <label>Blog Image 2</label>
        <input type="file" onChange={handleBlogImage2} className="form-control mb-2" />
        {preview.blog2 && <img src={preview.blog2} width="120" />}

        <label>Description Images</label>
        <input type="file" multiple onChange={handleDescriptionImages} className="form-control mb-2" />

        {/* SUBMIT */}
        <button type="submit" className="btn btn-success mt-3" disabled={isLoading}>
          {isLoading ? "Submitting..." : "Submit Blog"}
        </button>

      </form>
    </div>
  );
}

export default Addblog;